import type { FunctionComponent } from 'react';
import { ISubscriptionUpdatePaymentModal } from '../../../interfaces';
import PaymentsModal from '../PaymentsModal';
import RecurlyPaymentForm from '../RecurlyPaymentForm';

const SubscriptionUpdatePaymentModal: FunctionComponent<ISubscriptionUpdatePaymentModal> = ({
  onSuccess,
  onClose,
  isOpen,
  title,
  subtitle,
  hasError,
}) => (
  <PaymentsModal
    title={title || ''}
    subtitle={subtitle}
    isOpen={isOpen}
    onClose={onClose}
    hasError={hasError}
  >
    <RecurlyPaymentForm onSuccess={onSuccess} />
  </PaymentsModal>
);

export default SubscriptionUpdatePaymentModal;
